import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { IPostMessageData } from './window-message.model';

@Injectable({
  providedIn: 'root'
})
export class WindowMessageService {
  canPostMessage: boolean;
  messagesReceived$: Observable<MessageEvent> | undefined;

  constructor() {
    this.canPostMessage = typeof window?.postMessage === 'function';
  }

  /**
   * Sends a data message to a target window - most likely the site containing checkout as an embedded iframe
   * @param frame parent or specified window target
   * @param messageData data to go to the target. Should match what is expected in the host iframe script
   * @param targetOrigin what the origin of this window must be for event to be dispatched
   */
  postMessage(frame: 'parent' | Window, messageData: IPostMessageData, targetOrigin = '*'): void {
    if (!this.canPostMessage) {
      return;
    }

    const target: Window = frame === 'parent' ? window.parent : frame;

    target.postMessage(messageData, targetOrigin);
  }

  /**
   * Converts a window message listener to a single stream that can be shared app wide
   * @return raw message event stream as an observable
   */
  receiveMessage(): Observable<MessageEvent> {
    if (!this.messagesReceived$) {
      this.messagesReceived$ = fromEvent<MessageEvent>(window, 'message');
    }

    return this.messagesReceived$;
  }
}
